import React, { useState } from 'react';
import { TextField, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const LoginForm = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (username && password) {
      try {
        const response = await fetch('https://api.serconsciente.com.mx/api/auth', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ username, password }),
        });

        if (response.ok) {
          // Notificamos al App (o al LoginPage) que se inició sesión
          if (onLoginSuccess) {
            onLoginSuccess();
          }
          // Navegar a /admin
          navigate('/admin');
        } else {
          setError('Usuario o contraseña incorrectos.');
        }
      } catch (error) {
        console.error('Error al iniciar sesión:', error);
        setError('Error de conexión. Intenta nuevamente.');
      }
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
    <Container maxWidth="xs" className="mt-20 p-6 rounded-lg shadow-lg ">
      <Typography variant="h5" className="text-center mb-6 pb-4
      ">
        Iniciar Sesión
      </Typography>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <TextField
          label="Usuario"
          variant="outlined"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
        />
        <TextField
          label="Contraseña"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
        />
        {error && <Typography color="error">{error}</Typography>}
        <Button type="submit" variant="contained" color="primary" fullWidth>
          Entrar
        </Button>
      </form>
    </Container>
    </div>
  );
};

export default LoginForm;
// Compare this snippet from src/components/AdminPage.js: